// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cd9128b7","453":"bd58bb4d","455":"0c8a889c","977":"48faeb7b"}[chunkId] + ".chunk.js";
};